export const getDictionaries = (
  playerList,
  pairingList,
  isDoubleElimination = false,
  setHasRematch,
  startRoundNumber = 1
) => {
  const pairingDict = {};
  const bracketDict = {
    1: {
      label: "Championship Bracket",
      rounds: {
        [startRoundNumber]: {
          podNum: 1,
          label: `Round ${startRoundNumber}`,
          pairings: [],
        },
      },
    },
  };
  const playerDict = {};

  let numRounds = Math.ceil(Math.log2(playerList.length));
  let singleNumRounds = numRounds;
  let bracketSize = Math.pow(2, numRounds);
  let numPlayers = playerList.length;
  let slice = 1;

  if (isDoubleElimination) numRounds = numRounds * 2;

  if (playerList.length < bracketSize) {
    for (let i = 0; i < numPlayers && i < bracketSize - numPlayers; i++) {
      playerList.push({ bracket_seed: numPlayers + i });
    }
  }

  while (slice < playerList.length / 2) {
    let temp = [...playerList];
    playerList = [];

    while (temp.length > 0) {
      playerList.push(...temp.splice(0, slice));
      playerList.push(...temp.splice(-slice, slice));
    }

    slice = slice * 2;
  }

  var bracketPairingNum = 1;

  for (let i = 0; i < playerList.length; i += 2) {
    let pairing = {
      podNum: 1,
      bracketPairingNum: bracketPairingNum,
      player1: playerList[i],
      player2: playerList[i + 1],
    };
    if (playerList[i]?.id) {
      playerDict[playerList[i].id] = playerList[i];
    }
    if (playerList[i + 1]?.id) {
      playerDict[playerList[i + 1].id] = playerList[i + 1];
    }
    bracketDict[1].rounds[startRoundNumber].pairings.push(pairing);
    bracketPairingNum++;
  }

  for (let i = 2; i <= numRounds; i++) {
    let rPairings = [];
    let tempRoundNo = i + startRoundNumber - 1;
    let numPairings =
      i === singleNumRounds
        ? 1
        : Math.ceil(playerList.length / (2 * (i - 1)) / 2);
    let y = 1;

    for (let x = 1; x <= numPairings; x++) {
      rPairings.push({
        podNum: 1,
        bye: i > singleNumRounds && i < numRounds,
        bracketPairingNum: x,
        placeHolder: true,

        player1:
          isDoubleElimination && i === numRounds
            ? {
                linkedPairing: {
                  podNum: 1,
                  roundNo: singleNumRounds + startRoundNumber - 1,
                  bracketPairingNum: 1,
                  winner: true,
                },
              }
            : {
                linkedPairing: {
                  podNum: 1,
                  roundNo: tempRoundNo,
                  bracketPairingNum: y,
                  winner: true,
                },
              },
        player2:
          isDoubleElimination && i === numRounds
            ? {
                linkedPairing: {
                  podNum: 2,
                  roundNo: numRounds + startRoundNumber - 1,
                  bracketPairingNum: 1,
                  winner: true,
                },
                firstName: "Winner of EB Final",
              }
            : {
                linkedPairing: {
                  podNum: 1,
                  roundNo: tempRoundNo,
                  bracketPairingNum: y + 1,
                  winner: true,
                },
              },
      });
      y += 2;
    }
    bracketDict[1].rounds[tempRoundNo] = {
      podNum: 1,
      label: `Round ${tempRoundNo}`,
      bye: i > singleNumRounds && i < numRounds,
      pairings: rPairings,
    };

    if (i === numRounds && isDoubleElimination) {
      i++;
      tempRoundNo = i + startRoundNumber - 1;
      rPairings = [
        {
          bracketPairingNum: 1,
          placeHolder: true,
          player1: undefined,
          player2: {
            firstName: `Loser of CB Final`,
          },
        },
      ];
      bracketDict[1].rounds[tempRoundNo] = {
        podNum: 1,
        label: `Round ${tempRoundNo}`,
        bye: false,
        conditional: true,
        pairings: rPairings,
      };
    }
  }

  if (isDoubleElimination) {
    bracketDict[2] = {
      label: "Elimination Bracket",
      rounds: {
        [startRoundNumber]: {
          podNum: 2,
          label: `Round ${startRoundNumber}`,
          pairings: [],
        },
      },
    };

    for (let i = 2; i <= numRounds - 1; i++) {
      let rPairings = [];
      let tempRoundNo = i + startRoundNumber - 1;
      let tempPreviousRoundNo = tempRoundNo - 1;
      let pod1 = !bracketDict[1].rounds[tempPreviousRoundNo]?.bye
        ? bracketDict[1].rounds[tempPreviousRoundNo]?.pairings?.length || 0
        : 0;
      let pod2 =
        bracketDict[2].rounds[tempPreviousRoundNo]?.pairings?.length || 0;
      let pod2Byes =
        bracketDict[2].rounds[tempPreviousRoundNo]?.pairings?.filter(
          (el) => el.bye
        )?.length || 0;

      if (pod2 === 0) {
        // first round of elimination bracket
        let y = 1;
        for (let x = 1; x <= pod1 / 2; x++) {
          rPairings.push({
            placeHolder: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 1,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y,
                loser: true,
              },
              firstName: `Loser of CB ${tempPreviousRoundNo}.${y}`,
            },
            player2: {
              linkedPairing: {
                podNum: 1,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y + 1,
                loser: true,
              },
              firstName: `Loser of CB ${tempPreviousRoundNo}.${y + 1}`,
            },
          });
          y += 2;
        }
      } else if (pod1 === pod2) {
        // second round of elimination bracket
        for (let x = 1; x <= pod1; x++) {
          rPairings.push({
            placeHolder: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 1,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: pod1 + 1 - x,
                loser: true,
              },
              firstName: `Loser of CB ${tempPreviousRoundNo}.${pod1 + 1 - x}`,
            },
            player2: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: x,
                winner: true,
              },
            },
          });
        }
      } else if (pod2Byes > 0 && pod2 / 2 === pod2Byes) {
        let x = 1;
        for (; x <= pod1; x++) {
          rPairings.push({
            placeHolder: true,
            bye: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 1,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: x,
                loser: true,
              },
              firstName: `Loser of CB ${tempPreviousRoundNo}.${x}`,
            },
            player2: {
              x: 2,
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: x,
                winner: true,
              },
            },
          });
        }
        x = 1;
        for (let p of bracketDict[2].rounds[tempPreviousRoundNo]?.pairings) {
          if (p.bye) {
            let p1 = p.player1;
            let p2 = p.player2;
            if (p2?.linkedPairing?.roundNo) {
              p2.linkedPairing.roundNo++;
            }
            rPairings.push({
              placeHolder: true,
              bracketPairingNum: x,
              player1: p1,
              player2: p2,
            });
            x++;
          }
        }
      } else if (pod1 === 0 && pod2Byes > 0) {
        let x = 1;
        for (let p of bracketDict[2].rounds[tempPreviousRoundNo]?.pairings) {
          if (p.bye) {
            let p1 = p.player1;
            let p2 = p.player2;
            if (p2?.linkedPairing?.roundNo) {
              p2.linkedPairing.roundNo++;
            }
            rPairings.push({
              x: 4,
              placeHolder: true,
              bye: true,
              bracketPairingNum: x,
              player1: p1,
              player2: p2,
            });
            x++;
          }
        }

        let y = 1;
        for (let x = 1; x <= (pod2 - pod2Byes) / 2; x++) {
          rPairings.push({
            placeHolder: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y,
                winner: true,
              },
            },
            player2: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y + 1,
                winner: true,
              },
            },
          });
          y += 2;
        }
      } else if (pod1 === 1 && pod2 > 1) {
        let x = 1;
        let y = 1;
        for (; x <= pod2 / 2; x++) {
          rPairings.push({
            placeHolder: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y,
                winner: true,
              },
            },
            player2: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y + 1,
                winner: true,
              },
            },
          });
          y += 2;
        }
      } else if (pod1 <= 1 && pod2 === 1) {
        // final round of elimination bracket
        let topPreviousRoundNo = tempPreviousRoundNo;
        while (pod1 === 0 && topPreviousRoundNo > 0) {
          topPreviousRoundNo--;
          pod1 = !bracketDict[1].rounds[topPreviousRoundNo]?.bye
            ? bracketDict[1].rounds[topPreviousRoundNo]?.pairings?.length || 0
            : 0;
        }
        let x = 1;

        rPairings.push({
          placeHolder: true,
          bye: true,
          bracketPairingNum: x,
          player1: {
            linkedPairing: {
              podNum: 1,
              roundNo: topPreviousRoundNo,
              bracketPairingNum: x,
              loser: true,
            },
            firstName: `Loser of CB ${topPreviousRoundNo}.${x}`,
          },
          player2: {
            linkedPairing: {
              podNum: 2,
              roundNo: tempPreviousRoundNo,
              bracketPairingNum: x,
              winner: true,
            },
          },
        });
      } else {
        let x = 1;
        for (; x <= pod1; x++) {
          rPairings.push({
            placeHolder: true,
            bye: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 1,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: x,
                loser: true,
              },
              firstName: `Loser of CB ${tempPreviousRoundNo}.${x}`,
            },
            player2: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: x,
                winner: true,
              },
            },
          });
        }

        x = 1;
        let y = 1;
        for (; x <= pod2 / 2; x++) {
          rPairings.push({
            placeHolder: true,
            bracketPairingNum: x,
            player1: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y,
                winner: true,
              },
            },
            player2: {
              linkedPairing: {
                podNum: 2,
                roundNo: tempPreviousRoundNo,
                bracketPairingNum: y + 1,
                winner: true,
              },
            },
          });
          y += 2;
        }
      }

      bracketDict[2].rounds[tempRoundNo] = {
        podNum: 2,
        label: `Round ${tempRoundNo}`,
        pairings: rPairings,
        containsByes: rPairings.filter((el) => el.bye).length > 0,
        showMerge: pod2Byes > 0 && pod2 / 2 === pod2Byes,
      };
    }

    for (let i = 2; i <= numRounds - 1; i++) {
      let tempRoundNo = i + startRoundNumber - 1;

      bracketDict[2].rounds[tempRoundNo].nextRoundContainsByes =
        bracketDict[2].rounds[tempRoundNo + 1]?.containsByes;
      bracketDict[2].rounds[tempRoundNo].showMerge =
        bracketDict[2].rounds[tempRoundNo].showMerge ||
        (!bracketDict[2].rounds[tempRoundNo]?.containsByes &&
          bracketDict[1].rounds[tempRoundNo]?.pairings?.length !==
            bracketDict[2].rounds[tempRoundNo]?.pairings?.length);
    }
  }

  if (pairingList?.length > 0) {
    let xRound = 0;
    let xPod = 0;
    let xPairingNum = 0;
    for (let pairing of pairingList) {
      if (xPod !== pairing.podNum) {
        xPod = pairing.podNum;
        xPairingNum = 0;
      }
      if (xRound !== pairing.round) {
        xRound = pairing.round;
        xPairingNum = 0;
      }
      xPairingNum++;
      pairingDict[`${pairing.podNum}.${pairing.round}.${xPairingNum}`] =
        pairing;
      if (
        pairing.podNum === 1 &&
        bracketDict[pairing.podNum]?.rounds?.[pairing.round]?.pairings?.[
          xPairingNum - 1
        ]
      ) {
        bracketDict[pairing.podNum].rounds[pairing.round].pairings[
          xPairingNum - 1
        ] = {
          ...pairing,
          bracketPairingNum: xPairingNum,
          player1: {
            ...playerDict[pairing.player1?.id],
            ...pairing?.player1,
          },
          player2: {
            ...playerDict[pairing.player2?.id],
            ...pairing?.player2,
          },
        };
      }
    }

    if (isDoubleElimination) {
      if (
        pairingDict[`1.${numRounds}.1`]?.isDone &&
        pairingDict[`1.${numRounds}.1`]?.player1Game?.gameResult === 2
      ) {
        setHasRematch(false);
        delete bracketDict[1].rounds[numRounds + 1];
      }

      let rounds = Object.keys(bracketDict[2].rounds);
      for (let roundNo of rounds) {
        let round = bracketDict[2].rounds[roundNo];
        if (round?.pairings?.length) {
          for (let i = 0; i < round.pairings.length; i++) {
            if (
              !round.pairings[i]?.bye &&
              pairingDict[`2.${roundNo}.${round.pairings[i].bracketPairingNum}`]
            ) {
              let pairing =
                pairingDict[
                  `2.${roundNo}.${round.pairings[i].bracketPairingNum}`
                ];

              bracketDict[2].rounds[roundNo].pairings[i] = {
                ...pairing,
                bracketPairingNum: xPairingNum,
                player1: {
                  ...playerDict[pairing.player1?.id],
                  ...pairing?.player1,
                },
                player2: {
                  ...playerDict[pairing.player2?.id],
                  ...pairing?.player2,
                },
              };
            }
          }
        }
      }
    }
  }

  return { pairingDict, bracketDict };
};
